import './index.scss';
import React from 'react';
import intl from 'react-intl-universal';
import {
  Modal,
  Button,
  Input,
} from 'antd';
import { store } from '@/store';

export default class PromptDigitalIDPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: true,
      password: '',
    };
    this.passwordRef = React.createRef();
  }

  componentDidMount() {
    this.passwordRef.current && this.passwordRef.current.focus();
  }

  closeOnClick = () => {
    this.setState({ visible: false }, () => {
      this.props.onClose();
    });
  };

  okOnClick = async () => {
    const showErrorPassword = () => {
      store.appStore.onShowWarningMessage(undefined, {
        message: 'PromptDigitalIDPassword.ErrorPassword',
        iconType: 'error',
      }, true);
    }

    if (!this.state.password) {
      showErrorPassword();
      return;
    }

    const webPDFJR = await store.viewer.pdfui.getWebPDFJR();
    const b = await webPDFJR.checkCertificatePassword(this.props.digitalID.pfxFile, this.state.password);
    if (!b) {
      showErrorPassword();
      return;
    }

    this.setState({ visible: false }, () => {
      this.props.onClose(this.state.password);
    });
  };

  render() {
    const { digitalID = {} } = this.props;

    return (
      <Modal
        className="prompt-digital-id-password"
        width={530}
        visible={this.state.visible}
        title={intl.get('PromptDigitalIDPassword.Title')}
        onCancel={this.closeOnClick}
        getContainer={false}
        footer={[
          <Button key="cancel" onClick={this.closeOnClick}>{intl.get('Cancel')}</Button>,
          <Button key="ok" type="primary" onClick={this.okOnClick}>{intl.get('Ok')}</Button>,
        ]}
      >
        <div className="mb-10">{intl.get('PromptDigitalIDPassword.Desc')}</div>
        <div className="mb-10">{intl.get('PromptDigitalIDPassword.DigitalIDInfo')}</div>
        <div className="gray-bg">
          <div className="d-f ai-c mb-10">
            <div className="w-140 ta-r pr-10 fs-0">{intl.get('PromptDigitalIDPassword.Issuer')}</div>
            {digitalID.issuerName}
          </div>
          <div className="d-f ai-c mb-10">
            <div className="w-140 ta-r pr-10 fs-0">{intl.get('PromptDigitalIDPassword.Email')}</div>
            {digitalID.email}
          </div>
          <div className="d-f ai-c">
            <div className="w-140 ta-r pr-10 fs-0">{intl.get('PromptDigitalIDPassword.Password')}</div>
            <Input
              type="password"
              ref={this.passwordRef}
              value={this.state.password}
              onChange={e => this.setState({ password: e.target.value })}
              size="small"
              onPressEnter={this.okOnClick}
            />
          </div>
        </div>
      </Modal>
    );
  }
}